const StateIcon = (props: any) => {
  return (
    <div>
      <svg viewBox="0 0 54 62" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M27 13.4167C26.2265 13.4167 25.4846 13.1094 24.9376 12.5624C24.3906 12.0154 24.0833 11.2735 24.0833 10.5C24.0833 9.72645 24.3906 8.98458 24.9376 8.4376C25.4846 7.89062 26.2265 7.58333 27 7.58333C27.7735 7.58333 28.5154 7.89062 29.0624 8.4376C29.6094 8.98458 29.9167 9.72645 29.9167 10.5C29.9167 10.883 29.8412 11.2623 29.6946 11.6162C29.5481 11.97 29.3332 12.2916 29.0624 12.5624C28.7916 12.8332 28.47 13.0481 28.1162 13.1946C27.7623 13.3412 27.383 13.4167 27 13.4167ZM27 2.33333C24.8341 2.33333 22.7568 3.19374 21.2253 4.72529C19.6937 6.25684 18.8333 8.33406 18.8333 10.5C18.8333 16.625 27 25.6667 27 25.6667C27 25.6667 35.1667 16.625 35.1667 10.5C35.1667 8.33406 34.3063 6.25684 32.7747 4.72529C31.2432 3.19374 29.1659 2.33333 27 2.33333Z"
          stroke={props?.color ?? "black"}
          stroke-width="1.75"
        />
        <path
          d="M48.5 28L53 42V46.5V61.5H31H1V42L2.96429 37L6.5 28H17.5H35H48.5Z"
          fill={props?.color ?? "transparent"}
        />
        <path
          d="M35 28H48.5L53 42V46.5M35 28C35.3333 29 35.7 31 34.5 31C33 31 28.5 31.5 30 34C30.4473 34.7455 32.006 35.6687 34 36.624M35 28H17.5M53 46.5V61.5H31M53 46.5C47.5 47.5 47.5 43 46.5 42C45.7982 41.2982 38.6933 38.8725 34 36.624M34 36.624C33 38.0827 30.3 41 27.5 41C24.7 41 22 46 21 48.5M21 48.5C20.6 46.9 17.8333 44.1667 16.5 43M21 48.5C21.6667 48.8333 23.2 50 24 52C25 54.5 24.5 56 26.5 56.5C28.5 57 31 59.5 31 61.5M17.5 28H6.5L2.96429 37M17.5 28C18.1667 29 19.5 31.3 19.5 32.5C19.5 34 17.5 36 18.5 38C19.3 39.6 17.5 42 16.5 43M16.5 43C15 42.5 13 43 11 43C9 43 9 41.5 7.5 39C6.3 37 3.97619 36.8333 2.96429 37M2.96429 37L1 42V61.5H31"
          stroke={props?.color ?? "black"}
        />
      </svg>
    </div>
  );
};

export default StateIcon;